import { useEffect, useState } from "react";
import SEO from "../components/SEO";
import heroImage from "../assets/hero.webp";
import Irrigation3 from '../assets/Irrigation3.webp';

const WaterManagement = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  // Animation effect for sections
  useEffect(() => {
    const animateOnScroll = () => {
      const elements = document.querySelectorAll(".animate-fadeIn");
      elements.forEach((element) => {
        const elementPosition = element.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementPosition < windowHeight - 100) {
          element.classList.add("opacity-100", "translate-y-0");
        }
      });
    };

    window.addEventListener("scroll", animateOnScroll);
    animateOnScroll(); // Initialize check
    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  const irrigationTypes = [
    {
      name: "ड्रिप सिंचाई (Drip Irrigation)",
      desc: "पानी को सीधे पौधे की जड़ों तक बूंद-बूंद करके पहुँचाना, जिससे पानी की बर्बादी नहीं होती और पौधों को सही मात्रा में नमी मिलती है।",
      benefits: ["90% तक पानी की बचत", "खरपतवार नियंत्रण", "उर्वरक दक्षता में वृद्धि", "नमकीन पानी का भी उपयोग संभव", "ऊर्जा की बचत"],
    },
    {
      name: "स्प्रिंकलर सिंचाई (Sprinkler Irrigation)",
      desc: "पानी को हवा में छिड़काव करके बारिश की तरह गिराना, जो विशेष रूप से घास, गेहूं और अन्य फसलों के लिए उपयुक्त है।",
      benefits: ["समान जल वितरण", "70% पानी की बचत", "विभिन्न फसलों के लिए उपयुक्त", "मिट्टी के कटाव को रोकता है", "कम श्रम की आवश्यकता"],
    },
    {
      name: "सतह सिंचाई (Surface Irrigation)",
      desc: "खेत में पानी का प्रवाह करके सिंचाई करने की पारंपरिक विधि, जो समतल भूमि के लिए उपयुक्त है।",
      benefits: ["कम लागत वाली तकनीक", "सरल संचालन", "बड़े क्षेत्रों के लिए उपयुक्त", "कम रखरखाव लागत", "विभिन्न फसलों के अनुकूल"],
    },
    {
      name: "माइक्रो स्प्रिंकलर सिंचाई (Micro Sprinkler Irrigation)",
      desc: "छोटे क्षेत्रों में नियंत्रित छिड़काव करने वाली प्रणाली, जो फलों के बागानों के लिए आदर्श है।",
      benefits: ["पानी की 60-70% बचत", "फलों की गुणवत्ता में सुधार", "कम दबाव पर काम करती है", "असमान भूमि के लिए उपयुक्त", "फसलों को ठंडा रखने में मदद"],
    },
  ];

  const schemes = [
    {
      name: "प्रधानमंत्री कृषि सिंचाई योजना (PMKSY)",
      desc: "केंद्र सरकार की योजना जिसमें सूक्ष्म सिंचाई पर 55% से 100% तक अनुदान दिया जाता है। छोटे और सीमांत किसानों को विशेष लाभ। योजना के तहत ड्रिप और स्प्रिंकलर सिस्टम पर अधिकतम 5 हेक्टेयर तक सब्सिडी।",
    },
    {
      name: "राष्ट्रीय कृषि विकास योजना (RKVY)",
      desc: "राज्य सरकारों द्वारा क्रियान्वित योजना जिसमें सिंचाई परियोजनाओं के लिए वित्तीय सहायता प्रदान की जाती है। किसानों को जल संचयन संरचनाएं बनाने, कुएं खुदवाने और सिंचाई उपकरण खरीदने पर सहायता।",
    },
    {
      name: "कृषि तकनीकी प्रबंधन एजेंसी (ATMA)",
      desc: "किसानों को सिंचाई तकनीकों पर प्रशिक्षण और जागरूकता कार्यक्रम प्रदान करती है। विशेषज्ञों द्वारा मार्गदर्शन, प्रदर्शन खेत और सिंचाई प्रबंधन पर वर्कशॉप आयोजित की जाती हैं।",
    },
  ];

  const testimonials = [
    {
      name: "रमेश पाटिल, नासिक",
      quote: "ड्रिप सिंचाई से मेरी पानी की खपत आधी हो गई और उत्पादन 30% बढ़ गया! पहले 1 एकड़ में 5-6 घंटे सिंचाई करनी पड़ती थी, अब सिर्फ 2 घंटे में काम हो जाता है।",
    },
    {
      name: "सुमन देवी, राजस्थान",
      quote: "सरकारी अनुदान से स्प्रिंकलर लगवाया, अब कम मेहनत में अच्छी सिंचाई हो जाती है। खासकर गर्मियों में जब पानी की कमी होती है, यह सिस्टम बहुत कारगर साबित हुआ।",
    },
    {
      name: "विजय कुमार, पंजाब",
      quote: "माइक्रो स्प्रिंकलर ने मेरे संतरे के बाग की उत्पादकता दोगुनी कर दी। फलों का आकार और रंग भी पहले से बेहतर हुआ है।",
    },
    {
      name: "गीता शर्मा, मध्य प्रदेश",
      quote: "ATMA के प्रशिक्षण से सीखकर मैंने अपने खेत में वाटर शेड्यूलिंग अपनाई है। अब पानी की बर्बादी नहीं होती और फसल भी समय पर तैयार हो जाती है।",
    },
  ];

  const faqs = [
    {
      question: "ड्रिप सिंचाई के लिए कितनी लागत आती है और यह किन फसलों के लिए उपयुक्त है?",
      answer: "ड्रिप सिस्टम की लागत ₹20,000 से ₹50,000 प्रति एकड़ तक हो सकती है, लेकिन सरकारी अनुदान के बाद यह ₹10,000-₹25,000 तक कम हो जाती है। यह विधि विशेष रूप से सब्जियों (टमाटर, मिर्च, बैंगन), फलों (अंगूर, केला, अनार), नकदी फसलों (गन्ना, कपास) और बागवानी फसलों के लिए उत्तम है।",
    },
    {
      question: "सिंचाई के लिए सबसे अच्छी तकनीक कौन सी है और कैसे चुनें?",
      answer: "सर्वोत्तम सिंचाई तकनीक का चयन निम्न कारकों पर निर्भर करता है: 1) फसल का प्रकार - ड्रिप फलों और सब्जियों के लिए, स्प्रिंकलर अनाज फसलों के लिए 2) मिट्टी की प्रकृति - रेतीली मिट्टी के लिए बारंबार सिंचाई (ड्रिप), चिकनी मिट्टी के लिए कम बार 3) जल स्रोत की उपलब्धता - सीमित पानी में ड्रिप/स्प्रिंकलर 4) भूमि का ढलान - ढलानदार जमीन के लिए माइक्रो स्प्रिंकलर 5) आर्थिक स्थिति - कम लागत विकल्पों में ड्रिप सबसे कारगर",
    },
    {
      question: "सरकारी अनुदान के लिए आवेदन कैसे करें? कौन से दस्तावेज चाहिए?",
      answer: "आवेदन प्रक्रिया: 1) अपने क्षेत्र के कृषि अधिकारी से संपर्क करें 2) आवेदन पत्र भरें 3) आवश्यक दस्तावेज जमा करें 4) स्थल निरीक्षण होगा 5) अनुमोदन के बाद अनुदान राशि प्राप्त होगी\n\nआवश्यक दस्तावेज: भूमि के कागजात, आधार कार्ड, बैंक खाता विवरण, मोबाइल नंबर, पासपोर्ट साइज फोटो, खेत की फोटो, पिछले वर्ष की फसल का विवरण। SC/ST किसानों को जाति प्रमाण पत्र भी दिखाना होगा।",
    },
    {
      question: "सिंचाई प्रणालियों का रखरखाव कैसे करें?",
      answer: "1) नियमित रूप से फिल्टर साफ करें 2) पाइपलाइन में लीकेज की जांच करते रहें 3) सर्दियों में पानी निकालकर सिस्टम स्टोर करें 4) ड्रिपर्स/स्प्रिंकलर हेड्स की सफाई करें 5) पंप और मोटर का नियमित सर्विसिंग कराएं 6) वाल्व और कनेक्टर्स की जांच करें 7) मौसम के अनुसार सिंचाई शेड्यूल अपडेट करें",
    },
    {
      question: "जल संरक्षण के लिए कौन सी तकनीकें अपनाई जा सकती हैं?",
      answer: "1) वर्षा जल संचयन - खेत तालाब, छत जल संग्रहण 2) मल्चिंग - प्लास्टिक/कार्बनिक पदार्थों से मिट्टी ढकना 3) कंटूर बंधान - ढलान वाली भूमि में 4) भूजल पुनर्भरण - रिचार्ज पिट बनाना 5) फसल चक्र - कम पानी वाली फसलें उगाना 6) मिट्टी की नमी संरक्षण तकनीकें - जैविक खाद, कंपोस्ट का उपयोग",
    },
  ];

  return (
    <>
      <SEO
        title="जल प्रबंधन और सिंचाई तकनीक | कृषि विकास"
        description="आधुनिक सिंचाई तकनीकों, जल संरक्षण विधियों और सरकारी योजनाओं की जानकारी। ड्रिप, स्प्रिंकलर और अन्य सिंचाई प्रणालियों के बारे में विस्तृत मार्गदर्शन।"
        keywords="सिंचाई तकनीक, जल प्रबंधन, ड्रिप सिंचाई, स्प्रिंकलर, कृषि योजनाएं, जल संरक्षण, किसान सहायता"
      />

      {/* Hero Section */}
      <section 
        className="relative h-[70vh] flex items-center justify-center mt-16"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-center px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 animate-fadeIn opacity-0 translate-y-10 transition-all duration-500">
            <span className="bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
              सिंचाई और जल प्रबंधन
            </span>
          </h1>
          <p className="text-xl text-white max-w-2xl mx-auto animate-fadeIn opacity-0 translate-y-10 transition-all duration-500 delay-100">
            आधुनिक तकनीकों के माध्यम से जल संरक्षण और कुशल सिंचाई प्रबंधन
          </p>
        </div>
      </section>

      {/* Importance Section */}
      <section className="py-16 px-4 max-w-6xl mx-auto">
        <div className="animate-fadeIn opacity-0 translate-y-10 transition-all duration-500">
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
            सिंचाई का महत्व
          </h2>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-lg mb-4">
                सिंचाई कृषि उत्पादन का आधार है। भारत में 60% से अधिक कृषि भूमि सिंचाई पर निर्भर है। उचित जल प्रबंधन से:
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>फसल उत्पादकता में 30-50% की वृद्धि</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>जल संसाधनों का कुशल उपयोग (प्रति बूंद अधिक उपज)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>सूखे के प्रभाव को कम करना और फसल सुरक्षा</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>मिट्टी की उर्वरता बनाए रखना और भूजल स्तर में सुधार</span>
                </li>
                <li className="flex items-start">
                  <span className="text-green-500 mr-2">✓</span>
                  <span>वर्ष भर खेती की संभावना और बहुवर्षीय फसलों के लिए सहायक</span>
                </li>
              </ul>
            </div>
            <div className="rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300">
              <img src={Irrigation3} alt="सिंचाई का महत्व" className="w-full h-auto" />
              <div className="p-4 bg-white">
                <p className="text-gray-600">भारत में सिंचाई के प्रमुख स्रोत: 55% नहरें, 30% कुएं/ट्यूबवेल, 10% तालाब/जलाशय, 5% अन्य। आधुनिक तकनीकों से इन स्रोतों का अधिक कुशलता से उपयोग संभव है।</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Irrigation Types */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
            सिंचाई के प्रकार और उनके लाभ
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {irrigationTypes.map((type, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-2 animate-fadeIn opacity-0 translate-y-10"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <h3 className="text-xl font-semibold mb-3 text-green-700">{type.name}</h3>
                <p className="text-gray-600 mb-4">{type.desc}</p>
                <div className="border-t pt-3">
                  <h4 className="font-medium mb-2 text-blue-600">मुख्य लाभ:</h4>
                  <ul className="space-y-2">
                    {type.benefits.map((benefit, i) => (
                      <li key={i} className="flex items-start">
                        <span className="text-green-500 mr-2">•</span>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modern Systems */}
      <section className="py-16 px-4 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
          आधुनिक सिंचाई प्रणालियाँ और जल संरक्षण
        </h2>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="animate-fadeIn opacity-0 translate-y-10 transition-all duration-500">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 h-full">
              <h3 className="text-2xl font-semibold mb-4 text-blue-600">स्मार्ट सिंचाई प्रणाली</h3>
              <p className="mb-4">
                IoT आधारित सिस्टम जो मिट्टी की नमी, मौसम पूर्वानुमान और फसल की आवश्यकता के अनुसार स्वचालित रूप से सिंचाई नियंत्रित करते हैं। यह तकनीक विशेष रूप से बड़े खेतों और बागवानी के लिए उपयुक्त है।
              </p>
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-bold mb-2 text-blue-700">मुख्य विशेषताएँ और लाभ:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-blue-500 mr-2">⚡</span>
                    <span>मोबाइल ऐप से दूरस्थ नियंत्रण और मॉनिटरिंग</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-500 mr-2">⚡</span>
                    <span>पानी की बचत 40-60% और ऊर्जा दक्षता में सुधार</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-500 mr-2">⚡</span>
                    <span>मिट्टी की नमी सेंसर और वेदर स्टेशन से डेटा संग्रह</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-500 mr-2">⚡</span>
                    <span>फसल-विशिष्ट सिंचाई शेड्यूल और अलर्ट सिस्टम</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-500 mr-2">⚡</span>
                    <span>सरकारी अनुदान उपलब्ध (कुछ राज्यों में 75% तक)</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="animate-fadeIn opacity-0 translate-y-10 transition-all duration-500 delay-100">
            <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 h-full">
              <h3 className="text-2xl font-semibold mb-4 text-green-600">जल संरक्षण तकनीकें</h3>
              <p className="mb-4">
                पारंपरिक और आधुनिक विधियों का संयोजन करके जल संरक्षण किया जा सकता है। ये तकनीकें विशेष रूप से शुष्क और अर्ध-शुष्क क्षेत्रों के लिए उपयोगी हैं।
              </p>
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="font-bold mb-2 text-green-700">प्रभावी जल संरक्षण विधियाँ:</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">🌧️</span>
                    <span>वर्षा जल संचयन - खेत तालाब, पर्कोलेशन पिट, चेक डैम</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">💧</span>
                    <span>मल्चिंग तकनीक - प्लास्टिक/कार्बनिक पदार्थों से मिट्टी ढकना</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">🔄</span>
                    <span>पुनर्चक्रित जल का उपयोग - ग्रे वाटर मैनेजमेंट सिस्टम</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">🌱</span>
                    <span>सूखा प्रतिरोधी फसलें - बाजरा, चना, मूंग, अरहर आदि</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">🏞️</span>
                    <span>कंटूर खेती - ढलान वाली भूमि में मिट्टी और जल संरक्षण</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-green-500 mr-2">🌾</span>
                    <span>सस्य क्रियाएँ - समय पर बुवाई, अंतरफसली खेती, जीरो टिलेज</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Government Schemes */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
            सरकारी योजनाएँ और सहायता
          </h2>
          <div className="grid md:grid-cols-3 gap-6">
            {schemes.map((scheme, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fadeIn opacity-0 translate-y-10"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <h3 className="text-xl font-semibold mb-3 text-blue-700">{scheme.name}</h3>
                <p className="text-gray-600 mb-4">{scheme.desc}</p>
                <div className="mt-4">
                  <p className="text-sm text-gray-500">अधिक जानकारी के लिए अपने जिला कृषि अधिकारी से संपर्क करें</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Subsidy Info */}
      <section className="py-16 px-4 max-w-6xl mx-auto">
        <div className="bg-gradient-to-r from-green-500 to-blue-500 rounded-2xl p-8 text-white animate-fadeIn opacity-0 translate-y-10 transition-all duration-500">
          <h2 className="text-3xl font-bold mb-6">अनुदान और सहायता की विस्तृत जानकारी</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">सिंचाई प्रणालियों पर अनुदान (2023-24)</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <span className="text-yellow-300 mr-2">•</span>
                  <span>छोटे और सीमांत किसानों (2 हेक्टेयर तक) के लिए 55-75% अनुदान</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-300 mr-2">•</span>
                  <span>अनुसूचित जाति/जनजाति के किसानों के लिए अतिरिक्त 15% सब्सिडी</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-300 mr-2">•</span>
                  <span>पूर्वोत्तर राज्यों और पहाड़ी क्षेत्रों में 90% तक अनुदान</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-300 mr-2">•</span>
                  <span>महिला किसानों और किसान समूहों को प्राथमिकता</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-300 mr-2">•</span>
                  <span>अधिकतम सीमा: ₹50,000 प्रति हेक्टेयर (ड्रिप), ₹30,000 (स्प्रिंकलर)</span>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-semibold mb-4">आवेदन प्रक्रिया और पात्रता</h3>
              <ol className="space-y-3 list-decimal list-inside">
                <li>कृषि विभाग/कृषि तकनीकी प्रबंधन एजेंसी (ATMA) में संपर्क करें</li>
                <li>आवश्यक दस्तावेज: भूमि के कागजात, आधार कार्ड, बैंक विवरण, जाति प्रमाण पत्र (यदि लागू हो)</li>
                <li>खेत का स्थल निरीक्षण और तकनीकी रिपोर्ट</li>
                <li>सिस्टम की स्वीकृति और एमओयू पर हस्ताक्षर</li>
                <li>सिस्टम स्थापना के बाद अंतिम भुगतान</li>
                <li>3 वर्ष तक निगरानी और सहायता</li>
              </ol>
              <p className="mt-4 italic">नोट: अनुदान राशि सीधे किसान के बैंक खाते में DBT के माध्यम से भेजी जाती है</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
            किसानों के अनुभव और सफलता की कहानियाँ
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 animate-fadeIn opacity-0 translate-y-10 hover:bg-green-50"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start mb-4">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                    </svg>
                  </div>
                  <p className="italic text-gray-700">"{testimonial.quote}"</p>
                </div>
                <p className="font-medium text-right text-green-700">- {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
<section className="py-16 px-4 max-w-6xl mx-auto">
  <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
    सामान्य प्रश्न और उत्तर
  </h2>
  <div className="space-y-4 max-w-3xl mx-auto">
    {faqs.map((faq, index) => (
      <div 
        key={index}
        className={`border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 ${activeFaq === index ? 'shadow-lg bg-blue-50' : 'shadow-md hover:shadow-lg hover:border-blue-300'}`}
      >
        <button 
          className="w-full p-4 text-left font-medium transition-colors duration-200 flex justify-between items-center hover:bg-blue-100 rounded-t-xl"
          onClick={() => toggleFaq(index)}
          aria-expanded={activeFaq === index}
          aria-controls={`faq-${index}`}
        >
          <span className={`text-lg ${activeFaq === index ? 'text-blue-700 font-semibold' : 'text-gray-800'}`}>
            {faq.question}
          </span>
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`h-6 w-6 transition-transform duration-300 ${activeFaq === index ? 'transform rotate-180 text-blue-600' : 'text-gray-500'}`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
        <div 
          id={`faq-${index}`}
          className={`transition-all duration-300 overflow-hidden ${activeFaq === index ? 'max-h-96' : 'max-h-0'}`}
        >
          <div className="p-4 bg-white border-t border-gray-200">
            <p className="text-gray-700">{faq.answer}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</section>

    </>
  );
};

export default WaterManagement;